import { createBrowserRouter } from "react-router-dom";
import BaseLayout from "./components/base-layout";
import SuspenseLoader from "./components/loader/suspense-loader";
import { lazy, Suspense } from "react";

const Loader = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const PageNotFound = Loader(lazy(() => import("./components/page-not-found")));

const HomePage = Loader(lazy(() => import("./contents/homepage")));
const SelectOutFits = Loader(
  lazy(() => import("./contents/homepage/select-outfit"))
);
const SelectBackground = Loader(
  lazy(() => import("./contents/homepage/select-background"))
);
const Preview = Loader(lazy(() => import("./contents/homepage/preview")));
const Capture = Loader(lazy(() => import("./contents/homepage/capture")));
const FinalOutput = Loader(
  lazy(() => import("./contents/homepage/final-output"))
);
const ThankYou = Loader(lazy(() => import("./contents/homepage/thank-you")));

const TabHomePage = Loader(lazy(() => import("./contents/tab")));
const ShareThankYou = Loader(lazy(() => import("./contents/tab/ThankYou")));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <BaseLayout />,
    errorElement: <PageNotFound />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "/select-outfits", element: <SelectOutFits /> },
      { path: "/select-background", element: <SelectBackground /> },
      { path: "/preview", element: <Preview /> },
      { path: "/capture", element: <Capture /> },
      { path: "/final-output", element: <FinalOutput /> },
      { path: "/thank-you", element: <ThankYou /> },
      { path: "/share", element: <TabHomePage /> },
      { path: "/share/thank-you", element: <ShareThankYou /> },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
    errorElement: <PageNotFound />,
  },
]);
